
const home = {
nav: {
home: "Startseite",
about: "Über uns",
mission: "Mission",
moments: "Momente",
advertise: "Werben",
login: "Anmelden",
createAccount: "Konto erstellen",
},

hero: {
title: "Was gerade um dich herum passiert.",
subtitle: "Dein Vibe. Deine Stadt.",
description:
"Elnydo ist eine Social-Media-App, mit der du Videos und Bilder teilen und sehen kannst, was andere Menschen in deiner Umgebung gerade erleben. Keine Kommentare. Nur Likes und echte Momente.",
ctaCreateAccount: "Konto erstellen",
ctaLogin: "Anmelden",
quote:
"„Erlebe den Vibe in deiner Nähe.“ – Entdecke Partys, Straßen, Cafés und den Alltag um dich herum in Echtzeit.",
},

about: {
overlayTitle: "Live aus deiner Stadt",
overlaySubtitle: "Echte Momente. Genau jetzt.",
title: "Über uns",
p1:
"Elnydo ist eine Social-Media-App, auf der du Bilder und Videos veröffentlichen und entdecken kannst, was andere Menschen in deiner Umgebung teilen.",
p2:
"Dein Feed wird immer nach Entfernung sortiert – zuerst deine Stadt, dann dein Land und anschließend die Nachbarländer. Du musst nicht nach Inhalten suchen oder Hunderten von Konten folgen, um zu sehen, was gerade passiert: Elnydo zeigt dir in Echtzeit, was um dich herum geschieht.",
p3:
"Keine Kommentare, kein Drama und keine endlosen Diskussionen. Nur echte Momente, Likes und eine einfache Möglichkeit, den Vibe deiner Stadt zu erleben und neue Orte durch die Augen der Menschen zu entdecken, die dort leben.",
},

mission: {
title: "Unsere Mission",
missionLead: "Unsere Mission ist einfach:",
missionStatement:
"Menschen miteinander zu verbinden, indem wir zeigen, was um sie herum passiert.",
p1:
"Mit Elnydo siehst du die Welt durch die Augen echter Menschen – nicht durch inszenierte Werbung oder endlose Kommentarspalten. Dein Feed beginnt in deiner Stadt, erweitert sich auf dein Land und anschließend auf die Nachbarländer – wie das Herauszoomen auf einer lebendigen Karte voller Momente.",
p2:
"Jedes Video und jedes Bild ist ein kleines Fenster in das, was gerade passiert: Partys, Straßen, Cafés, Konzerte und das alltägliche Leben. Du scrollst nicht einfach durch einen Feed – du erkundest eine lebendige Welt.",
overlayTitle:
"Eine Welt voller Momente.",
overlaySubtitle:
"Von deiner Straße bis ins nächste Land – alles in einer einzigen Ansicht.",
},

moments: {
title: "Momente aus aller Welt",
description:
"Hier kannst du Beispielvideos aus deiner App präsentieren. Am besten werden sie als anklickbare Links eingebunden, damit Besucher direkt einen ersten Eindruck von der App und echten Beiträgen aus ausgewählten Städten erhalten.",
cards: {
paris: {
title: "Paris • Eiffelturm",
description: "Lichter der Nacht, Straßenmusik und Freunde, die gemeinsam den Abend genießen.",
},
london: {
title: "London • Big Ben",
description: "Regnerischer Abend, Stadtlichter und Spaziergänge bis spät in die Nacht.",
},
vienna: {
title: "Wien • Schloss Schönbrunn",
description: "Goldene Stunde in der Stadt – ruhig und wunderschön.",
},
},
},

ads: {
title: "Werbung auf Elnydo",
description:
"Erzähle deine Geschichte mit immersiver, filmischer Werbung, die sich natürlich in das Nutzererlebnis einfügt – statt aufdringlich zu wirken.",
subtext:
"Erreiche echte Menschen in den Momenten, die zählen. Datenschutzfreundlich, markensicher und für modernes Storytelling entwickelt.",
cta: "Auf Elnydo werben",
},

cta: {
title: "Bereit zu sehen, was um dich herum passiert?",
description:
"Erstelle kostenlos ein Konto, teile deine ersten Momente und entdecke deine Stadt – ein Video nach dem anderen.",
createAccount: "Konto erstellen",
login: "Anmelden",
},

footer: {
tagline: "Was gerade um dich herum passiert.",
links: {
termsOfUse: "Nutzungsbedingungen",
privacyPolicy: "Datenschutzerklärung",
helpSupport: "Hilfe & Support",
},

language: "Sprache",
},
};
export default home;
